import { ExtraGym } from '../../types/ExtraGym';

export const fetchExtraGyms = async (baseGymId: string, monthlyPrice: string): Promise<ExtraGym[]> => {
  const publicHussleDomain = process.env.NEXT_PUBLIC_HUSSLE_DOMAIN;

  const endpoint = `${publicHussleDomain}/search/extra-gym.json`;

  const urlParams = new URLSearchParams();
  urlParams.append('id', baseGymId);
  urlParams.append('page', '1');
  urlParams.append('limit', '6');
  urlParams.append('price', monthlyPrice);

  const response = await fetch(`${endpoint}?${urlParams}`);

  if (response.status !== 200) {
    const { status, statusText } = response;

    const text = await response.text();
    const message = `Status: ${status} Endpoint: ${endpoint} StatusText: ${statusText} Body: ${text}`;
    throw new Error(message);
  }

  let parsedResponse = null;
  try {
    parsedResponse = await response.json();
  } catch (e) {
    throw new Error('unable to decode json. Response body text: ' + (await response.text()));
  }

  if (parsedResponse.success == false) {
    throw new Error('API did not return success. Errors: ' + parsedResponse.errors);
  }

  const extraGyms = parsedResponse.datas.gyms;

  return <ExtraGym[]>extraGyms;
};
